export const REQUESTOR = 'upload-and-print-booklets';
export const ESI_BOOKEND_TENANT = 'vistaprint';
export const UPLOAD_MAX_SIZE_MB = 512;
export const UPLOAD_MAX_SIZE_KB = UPLOAD_MAX_SIZE_MB * 1024;
export const UPLOAD_ERRORS_LOCALE_KEY_MAP = {
  'Your file has non-embedded fonts.': 'upload.non embedded fonts error.error-message',
  'Your file has non-embedded fonts in pages.': 'upload.non embedded fonts error.message',
  'File processing failed, file is password protected.': 'upload.password error.message',
  'File format not supported for image processing.': 'upload.image error.message',
  'Please embed all fonts in your file before uploading.': 'validations.non embedded fonts.error-body-description',
  'Undetected un-embedded fonts in the file.': 'validations.UnEmbeddedFontsValidator.message',
};

export enum experienceType {
  productPage = 'Product%20Page',
  pdcPage = 'Post%20Design%20Config%20Page',
}
export const PERFECT_BOUND_PRODUCT_KEYS = ['PRD-ZJ6EMXNJY', 'PRD-7HJNYRSTO'];

export const DEFAULT_PREVIEW_WIDTH_REQUEST = 1000;

/**
 * The number of cover pages in the uploaded PDF for a perfect bound product.
 */
export const PERFECT_BOUND_PDF_COVER_PAGE_COUNT = 2;

// This is for initial set of pages with non-embedded fonts. The count is limited to 6 to keep the error message short.
export const UN_EMBEDDED_FONTS_PAGE_LIMIT = 6;
export const UPLOAD_SOURCE = 'local_device';
export const UPLOAD_UNIFIED_EVENT = 'Upload Component Engaged';
export const BUTTON_CLICKED_EVENT = 'Button Clicked';
export enum UploadSteps {
  UploadStarted = 'upload_started',
  UploadCompleted = 'upload_completed',
  UploadFailed = 'upload_failed',
  UploadCanceled = 'upload_canceled',
  ComponentViewed = 'component_viewed',
  ProcessingCompleted = 'processing_completed',
  ValidationFailed = 'validation_failed',
  ValidationWarning = 'validation_warning',
  RecommendationModalViewed = 'recommendation_modal_viewed',
  RecommendationModalClicked = 'recommendation_modal_clicked',
  SpecsTemplatesViewed = 'specs_templates_viewed',
  TemplateDownloaded = 'template_downloaded',
  FileReplaced = 'file_replaced',
  FileDeleted = 'file_deleted',
  FilePreviewed = 'file_previewed',
}

export enum ValidationNames {
  CorruptValidator = 'CorruptValidator',
  PageSizeValidator = 'PageSizeValidator',
  PageCountValidator = 'PageCountValidator',
  PageOrientationValidator = 'PageOrientationValidator',
  ImageResolutionValidator = 'ImageResolutionValidator',
  EncryptedValidator = 'EncryptedValidator',
}
